import { QueryKey } from '@gogame/query';

const GROUPS = 'groups';
const MOVE_TO = 'moveTo';
const GROUPED = 'grouped';

const MOVE_TO_UNGROUPED = 'moveToUngrouped';
const MUTATIONS_RENAME_GROUP = 'renameGroup';
const MUTATIONS_DELETE_GROUP = 'deleteGroup';
export const presetsKey = new QueryKey('presets');

export const grid = presetsKey.grid();
export const grids = presetsKey.grids();
export const groupedPresets = presetsKey.exact(GROUPED);

export const groups = presetsKey.exact(GROUPS);
export const mutations = presetsKey.mutations();

export const create = mutations.create();
export const createGroup = mutations.create();
export const renameGroup = mutations.mutate(MUTATIONS_RENAME_GROUP);

export const deleteGroup = mutations.mutate(MUTATIONS_DELETE_GROUP);
export const moveTo = mutations.mutate(MOVE_TO);
export const moveToUngrouped = mutations.mutate(MOVE_TO_UNGROUPED);

export const update = mutations.update();
export const remove = mutations.delete();
export const updateUsageDate = mutations.update();
export const updateGroup = mutations.update();
